import styled from 'styled-components'

export const StyledNavContent = styled.div`
    width: 100%;
    height: 90%;
    overflow: auto;
    display: block;
    position: absolute;
`